import { robotoRegular } from '@habitech/shared';
import styled from 'styled-components';

export const WrapperThumbnails = styled.div`
  width: 180px;
  height: calc(100vh - (135px + 76px));
  overflow-y: auto;
  border-right: 1px solid #ddd;
`;

export const WrapperDocuments = styled.div`
  position: relative;
  flex: 1;
  height: calc(100vh - (135px + 76px));
  .rotate-buttons {
    position: absolute;
    top: -35px;
    right: 1px;
    z-index: 1000;
    align-items: center;
    background-color: #eeeeee;
    border-radius: 4px;
    display: flex;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  }
  .rpv-core__tooltip,
  .rpv-core__tooltip-body {
    display: none !important;
    visibility: hidden !important;
    pointer-events: none !important;
  }
  .img-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    overflow: auto;
  }
  .img-container img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  .img-container img.rotated {
    max-width: 90vh;
    max-height: 90vw;
  }
`;

export const WrapperDocs = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
  cursor: pointer;
  border: 1px solid #ddd;
  text-align: center;
  align-items: center;
  width: 166px;
  height: 134px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 1);
  .title {
    font-family: ${robotoRegular};
    font-size: 14px;
    color: rgba(92, 90, 93, 1);
  }
`;

export const WrapperButton = styled.div`
  button,
  .tab-trigger {
    padding: 10px 16px;
    font-size: 14px;
    color: rgba(33, 32, 33, 1);
    font-weight: 600;
    font-family: ${robotoRegular};
    background: rgba(243, 243, 243, 1);
    border: 1px solid rgba(243, 243, 243, 1);
  }
  button.selected-tab,
  .tab-trigger.selected-tab {
    background-color: white;
    color: rgba(33, 32, 33, 1);
    font-family: ${robotoRegular};
    font-weight: bold;
  }
`;
